import React from "react";
import { Button } from "react-bootstrap";
import {faQrcode, faCircleNotch, faTimes} from "@fortawesome/free-solid-svg-icons";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
const QrScanner = require("qr-scanner").default;
QrScanner.WORKER_PATH = "/external/qrscanner/qr-scanner-worker.min.js";


export default class QRCodeScanner extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            isRunning: false,
            isLoading: false,
        }
        this.scanner = null;

        this.handleScanResult = this.handleScanResult.bind(this);
        this.handleScanError  = this.handleScanError.bind(this);
        this.handleStart      = this.handleStart.bind(this);
        this.handleStop       = this.handleStop.bind(this);
    }

    handleScanResult(result) {
        if (typeof this.props["validator"] !== "undefined") {
            if (!this.props.validator(result.data)) return;
        }
        this.props.onScannerResult(result.data);
        this.setState({isLoading: false, isRunning: false});
        this.scanner.stop();
        this.scanner.destroy();
        this.scanner = null;
    }

    handleScanError(err){
        this.props.onScannerError(err);
    }

    handleStart(){
        this.setState({isLoading: true});
        this.props.onScannerStart(async () => {
            if (this.scanner === null){
                this.scanner = new QrScanner(this.props.previewRef.current, this.handleScanResult, {
                    highlightScanRegion: true,
                    highlightCodeOutline: true,
                    onDecodeError: this.handleScanError
                });
            }
            await this.scanner.start();
            this.setState({isLoading: false, isRunning: true});
        });
    }

    handleStop(){
        //this.props.onScannerStop();
        this.setState({isLoading: false, isRunning: false});
        this.scanner.stop();
    }

    render() {
        return (
            this.state.isRunning ? (
                <Button
                    className={`btn btn-red ${this.props.className}`}
                    onClick={() => this.handleStop()}>
                    <FontAwesomeIcon icon={faTimes} /> {this.props.content}
                </Button>
            ) : (
                <Button
                    className={`btn btn-green ${this.props.className}`}
                    onClick={() => this.handleStart()}>
                    {this.state.isLoading ?
                        <FontAwesomeIcon icon={faCircleNotch} spin /> : <FontAwesomeIcon icon={faQrcode} />
                    } {this.props.content}
                </Button>
            )
        );
    }
}
